module.exports = {
      id: "close-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite-f7c87499d4b6955c7faa356accbb279e.svg#close",
      toString: function () {
        return this.url;
      }
    }